import { render, staticRenderFns } from "./CarouselModal.vue?vue&type=template&id=030b5106&"
import script from "./CarouselModal.vue?vue&type=script&lang=js&"
export * from "./CarouselModal.vue?vue&type=script&lang=js&"
import style0 from "./CarouselModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports